import {gql, useLazyQuery} from '@apollo/client'
import paginationLimit from '../configs/paginationLimit.json'
import {useSelector} from 'react-redux'

export const GET_CATEGORIZED_INTEREST_TAGS_REF_DATA = gql`
  query GetCategorizedInterestTagsRefData(
    $category: String
    $searchWord: String
    $limit: Int
    $startIndex: Int
    $azureRole: String
  ) {
    categoryTags(
      category: $category
      searchWord: $searchWord
      limit: $limit
      startIndex: $startIndex
      azureRole: $azureRole
    ) {
      category
      totalInterestTagCount
      interestTagList {
        id
        name
      }
    }
  }
`

export default function useCategorizedInterestTagsRefData(tagCategory, interestTagCount, searchTerm = '') {
  const categoryName = tagCategory ?? ''
  const tagStartIndex = tagCategory ? paginationLimit.pagination.cateogryInterestTagLimt + 1 : 0
  const azureRole = useSelector((state) => state.superUserTenantSlice.azureRole)
  const limit = tagCategory ? interestTagCount : paginationLimit.pagination.cateogryInterestTagLimt
  const [
    getCategorizedInterestTagsRefData,
    {data: interestRefData, loading: isInterestRefDataLoading, error: interestRefDataError, refetch}
  ] = useLazyQuery(GET_CATEGORIZED_INTEREST_TAGS_REF_DATA, {
    variables: {
      category: categoryName,
      searchWord: searchTerm,
      limit,
      startIndex: tagStartIndex,
      ...(azureRole ? {azureRole} : {})
    },
    notifyOnNetworkStatusChange: true,
    fetchPolicy: 'network-only',
    errorPolicy: 'all'
  })
  return [getCategorizedInterestTagsRefData, {interestRefData, isInterestRefDataLoading, interestRefDataError, refetch}]
}
